<template>
  <el-dialog
    title="预览"
    :visible.sync="visible"
    width="800px"
    @close="$emit('update:show', false)"
    @open="opened"
  >
    <div
      slot="title"
      class="flex-row-between el-dialog__header"
      v-loading="loading"
    >
      <span class="el-dialog__title">预览</span>
      <div>
        <el-button
          v-if="print"
          icon="el-icon-printer"
          size="medium"
          type="primary"
          round
          plain
          v-print="'#PrintQuotation'"
          >打印</el-button
        >
        <template v-if="!editPreview && quotation && quotation.id > 0"
          ><el-button
            icon="el-icon-printer"
            size="medium"
            type="primary"
            round
            plain
            @click="downloadPdf()"
            >下载PDF</el-button
          >
          <!-- <el-button
            icon="el-icon-printer"
            size="medium"
            type="primary"
            round
            plain
            @click="getExcel()"
            >下载Excel</el-button> -->
        </template>
        <span class="text-gray" v-else> 保存后可以下载PDF或Excel文件 </span>
      </div>
    </div>
    <quotation-print
      ref="pdfContent"
      :quotation="quotation"
      :fee="fee"
    ></quotation-print>
    <!-- <vue-html2pdf
      v-if="quotation"
      :show-layout="false"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename="'报价单' + quotation.number"
      :pdf-quality="2"
      :manual-pagination="false"
      :htmlToPdfOptions="{ margin: 10, html2canvas: { useCORS: true } }"
      pdf-format="a4"
      pdf-orientation="portrait"
      ref="html2Pdf"
      pdf-content-width="800px"
      @progress="onProgress($event)"
    >
      <section slot="pdf-content">
        <quotation-print :quotation="quotation" :fee="fee"></quotation-print>
      </section>
    </vue-html2pdf> -->
    <div style="text-align: right" class="mt-20">
      <el-button
        v-if="print"
        icon="el-icon-printer"
        size="medium"
        type="primary"
        round
        plain
        v-print="'#PrintQuotation'"
        >打印</el-button
      >
      <template v-if="!editPreview && quotation && quotation.id > 0"
        ><el-button
          icon="el-icon-printer"
          size="medium"
          type="primary"
          round
          plain
          @click="downloadPdf()"
          >下载PDF</el-button
        >
        <!-- <el-button
          icon="el-icon-printer"
          size="medium"
          type="primary"
          round
          plain
          @click="getExcel()"
          >下载Excel</el-button> -->
      </template>
      <span class="text-info-12" v-else> 保存后可以下载PDF或Excel文件 </span>
    </div>
  </el-dialog>
</template>

<script>
import QuotationPrint from './quotation_print'
import Vue from 'vue'
import { exportQuotation } from '../service/getData'
import { host, urlPerfix } from '@/config/env'

import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

export default {
  components: { QuotationPrint },
  props: {
    quotation: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    fee: {
      type: Object,
    },
    print: {
      type: Boolean,
      default: false,
    },
    editPreview: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      loading: false,
      visible: this.show,
    }
  },
  created() {},
  methods: {
    opened() {},
    onProgress(event) {},
    async downloadPdf() {
      let title = '报价单' + this.quotation.number
      let a4Height = 841.89
      let a4Width = 595.28
      let ele = document.querySelector('#PrintQuotation')
      ele.parentNode.style.overflow = 'visible'
      let that = this
      let scale = 2
      let rect = ele.getBoundingClientRect()
      let eleWidth = rect.width
      let eleHeight = rect.height

      html2Canvas(ele, {
        dpi: 144,
        scale: scale,
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        width: eleWidth,
        height: eleHeight,
      }).then(function (canvas) {
        var context = canvas.getContext('2d')
        // 【重要】关闭抗锯齿
        context.mozImageSmoothingEnabled = false
        context.webkitImageSmoothingEnabled = false
        context.msImageSmoothingEnabled = false
        context.imageSmoothingEnabled = false

        let cw = eleWidth
        let ch = eleHeight
        let marginX = 40
        let marginY = 60
        // 显示区域大小
        let displayWidth = a4Width - marginX * 2
        let displayHeight = a4Height - marginY * 2
        // 比率
        let radio = cw / displayWidth
        // 换算高度
        let th = ch / radio

        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let PDF = new JsPDF('', 'pt', 'a4')

        if (th < displayHeight) {
          PDF.addImage(pageData, 'JPEG', marginX, marginY, displayWidth, th)
        } else {
          // 计算分隔线
          let computedHeight = 0
          let fixedHeight = displayHeight * radio
          // 位置修正
          let beginY = ele.getBoundingClientRect().y

          let slices = []
          while (computedHeight < ch) {
            let target = that.getElementChildrenByTop(
              ele,
              fixedHeight + computedHeight,
              beginY
            )

            let targetRect = target.getBoundingClientRect()
            let realHeight =
              targetRect.y - beginY + targetRect.height - computedHeight
            let borderFixed = 0
            if (target.nodeName == 'TR') {
              borderFixed = 1 * scale
            }

            slices.push({
              height: realHeight,
              fixed: borderFixed,
            })
            computedHeight += realHeight
          }

          let pages = slices.length
          let renderedHeight = 0
          let borderFixed = 0
          for (let i = 0; i < pages; i++) {
            const slice = slices[i]
            let img = context.getImageData(
              0,
              (renderedHeight - borderFixed) * scale,
              cw * scale,
              slice.height * scale
            )
            let tmpCanvas = document.createElement('canvas')
            let tmpCtx = tmpCanvas.getContext('2d')
            let tmpCanvasWidth = cw * scale
            let tmpCanvasHeight = fixedHeight * scale + marginY * scale
            tmpCtx.scale(scale, scale)
            tmpCanvas.width = tmpCanvasWidth
            tmpCanvas.height = tmpCanvasHeight
            tmpCtx.fillStyle = '#fff'
            tmpCtx.fillRect(0, 0, tmpCanvasWidth, tmpCanvasHeight)
            tmpCtx.putImageData(img, 0, 0, 0, 0, img.width, img.height)

            tmpCtx.fillStyle = '#888'
            tmpCtx.font = '24px Arial'
            tmpCtx.textAlign = 'center'
            tmpCtx.fillText(
              '第' + (i + 1) + '/' + pages + '页',
              tmpCanvasWidth / 2,
              tmpCanvasHeight - (marginY * scale) / 2
            )
            let res = tmpCanvas.toDataURL('image/jpeg', 1.0)
            PDF.addImage(
              res,
              'JPEG',
              marginX,
              marginY,
              displayWidth,
              displayHeight + marginY
            )

            renderedHeight += slice.height
            borderFixed = slice.fixed

            if (i < pages - 1) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
      })
    },
    getElementChildrenByTop(ele, top, start) {
      let len = ele.children.length
      for (let i = 0; i < ele.children.length; i++) {
        const child = ele.children[i]
        const rect = child.getBoundingClientRect()
        let y = rect.y - start
        let ty = y + rect.height
        const marginTop = parseInt(window.getComputedStyle(child).marginTop)
        // 如果边距已超出需求高度
        if (y + marginTop > top) {
          if (i > 0) {
            return ele.children[i - 1]
          } else {
            return child.parentNode
          }
        }
        if (ty > top) {
          // 非根节点继续找
          let containerNodes = ['TABLE', 'DIV', 'UL', 'OL', 'TBODY']
          if (
            child.children.length > 0 &&
            containerNodes.indexOf(child.nodeName) != -1
          ) {
            return this.getElementChildrenByTop(child, top, start)
          }
          // 如果不是第一个节点则返回本节点的上一个节点
          if (i > 0) {
            return ele.children[i - 1]
          }
          // 递归到最近的一个兄弟元素
          else {
            let parent = child.parentNode
            let grand = parent.parentNode
            while (grand.children.length < 1) {
              grand = grand.parentNode
            }

            for (let j = 0; j < grand.children.length; j++) {
              const ele = grand.children[j]
              if (ele == parent && j > 0) {
                return grand.children[j - 1]
              }
            }
          }
        }
      }
      return ele
    },
    async getExcel() {
      this.loading = true
      let res = await exportQuotation(this.quotation.id)
      if (res.code == 0) {
        window.location.href = res.data
      }
      this.loading = false
    },
  },
}
</script>

<style scoped>
/deep/.el-dialog__body {
  padding-left: 30px;
  padding-right: 30px;
}
</style>